import Component from '@glimmer/component';

export default class RecordExplorerTableTdSanizeHtml extends Component {
  // Getter and setter
  get value() {
    const property = this.args.column.property;
    let element = document.createElement('div');
    let value = this.args.record[property];
    value = value?.replaceAll(/<br\s*\/?>/g, ' ');
    element.innerHTML = value ? value : '';
    return element.innerText;
  }

  // Template
  <template>{{this.value}}</template>
}
